import LoadingScreen from './loading-screen';
export default LoadingScreen;
